import YYSelectMemberInput from './select-member-input.vue'

export default YYSelectMemberInput